/* eslint-disable react/no-unknown-property */
import { FC, Suspense } from 'react';
import { Canvas } from '@react-three/fiber';
import { Box, useAsset } from '@altermaind/web/ui';
import { Avatar } from './Avatar';

type Props = {
  speaking?: boolean;
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const AvatarStatic3D: FC<Props> = ({ speaking = false }) => {
  const office = useAsset('images', 'office');
  const avatarGLB =
    '/models/6906143c786317131ce13352.glb?morphTargets=mouthSmile,mouthOpen,mouthFunnel,eyeBlinkLeft,eyeBlinkRight';

  return (
    <Box
      width='100%'
      height='100%'
      style={{
        backgroundImage: `url('${office}')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <Canvas camera={{ position: [0, 0.3, 2], fov: 70 }}>
        <ambientLight intensity={1.6} />
        <directionalLight intensity={0.8} />
        <Suspense
          fallback={
            <mesh>
              <boxGeometry args={[1, 1, 1]} />
              <meshStandardMaterial color='gray' />
            </mesh>
          }
        >
          <Avatar url={avatarGLB} />
        </Suspense>
      </Canvas>
    </Box>
  );
};
